import { createReducer } from "../../../common/reduxUtil";
import {
  DMAT_SET_OVERVIEW,
  DMAT_SET_LOADING,
  DMAT_SET_LOAD_ERROR,
} from "./types";

const initialState = {
  overview: null,
  loading: true,
  loadError: "",
};

export default createReducer(initialState, {
  [DMAT_SET_OVERVIEW]: (state, overview) => ({ ...state, overview }),
  [DMAT_SET_LOADING]: (state, loading) => ({ ...state, loading }),
  [DMAT_SET_LOAD_ERROR]: (state, loadError) => ({ ...state, loadError }),
});
